import { z } from 'zod';

export const groupFormSchema = z.object({
  groupName: z
    .string()
    .min(1, 'Group name is required')
    .max(120, 'Too long')
    .regex(/^[A-Za-z0-9_\- ]+$/, 'Letters, digits, spaces, _ and - only'),
  /** Stringified dialer IDs picked in the multi-select. */
  dialerIds: z.array(z.string()).min(1, 'Select at least one dialer'),
});

export type GroupFormInput = z.infer<typeof groupFormSchema>;
